import { createPortal } from 'react-dom';

function Portal({children,wrapperId = "portal-root"}) {
    return createPortal(children, document.getElementById(wrapperId));
}

export default Portal